import { useState, useEffect } from "react";
import { BarChartOutlined, AppstoreOutlined, DownOutlined } from "@ant-design/icons";
import type { AccountCard } from "../../hooks/useGBPGroups";

interface Props {
  accounts: AccountCard[];
  onSelect: (id: string) => void;
  onPerformance: (resource: string, name: string) => void;
  subjectEmail: string;  
}

const GBPGroupsSelector: React.FC<Props> = ({
  accounts,
  onSelect,
  onPerformance,
  subjectEmail,  
}) => {
   const DEFAULT_ID_MAP: Record<string, string> = {
    "g.noura@metal2000.fr": "102770176164362989528",
    "l.zayneb@metallerie-grand-paris.com": "109266092858801549869",
    "b.emna@hbhs.fr": "104964969645737494428",
  };

  const DEFAULT_ID = DEFAULT_ID_MAP[subjectEmail] || "102770176164362989528";

  const [selectedId, setSelectedId] = useState<string>(DEFAULT_ID);

  const selectedAccount = accounts.find((acc) => acc.id === selectedId);

  useEffect(() => {
     setSelectedId(DEFAULT_ID);
  }, [subjectEmail, DEFAULT_ID]);

  useEffect(() => {
    if (selectedId) {
      onSelect(selectedId);
    }
  }, [selectedId, onSelect]);

  return (
    <div className="w-full bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
      <div className="flex flex-col md:flex-row items-center gap-4">
        <div className="relative flex-1 w-full group">
          <label className="absolute -top-2 left-3 px-1 bg-white text-[10px] font-bold uppercase tracking-wider text-blue-600 z-10">
            Groupe Business Profile
          </label>
          <div className="relative flex items-center">
            <select
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              className="appearance-none w-full pl-10 pr-10 py-3 rounded-xl border border-slate-200 text-sm font-medium text-slate-700 bg-slate-50/50 hover:bg-white hover:border-blue-400 focus:outline-none focus:ring-4 focus:ring-blue-500/10 transition-all cursor-pointer"
            >
              <option value="" disabled>Sélectionner un groupe...</option>
              {accounts.map((acc) => (
                <option key={acc.id} value={acc.id}>
                  {acc.id === DEFAULT_ID ? "🌐 Toutes les fiches" : acc.name}
                </option>
              ))}
            </select>
            <AppstoreOutlined className="absolute left-3.5 text-slate-400 text-base" />
            <DownOutlined className="absolute right-3.5 text-slate-400 text-[10px] pointer-events-none group-hover:text-blue-500" />
          </div>
        </div>

        {selectedAccount && (
          <div className="flex items-center gap-2 w-full md:w-auto">
            <button
              onClick={() => onPerformance(selectedAccount.resourceName, selectedAccount.name)}
              title="Statistiques de performance"
              className="flex items-center justify-center h-[46px] w-[46px] rounded-xl border border-blue-100 text-blue-600 bg-blue-50 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300 shadow-sm"
            >
              <BarChartOutlined style={{ fontSize: '18px' }} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GBPGroupsSelector;